/* @ngInject */

export default (
  $state,
  $rootScope,
  $scope,
  $location,
  $filter,
  webpage,
  accountService,
  organizationService,
  organizationsService,
  changesService,
  eventService,
  navigationService,
  uiService,
  ORGANIZATION
) => {
  $scope.Model = {
    availableOrganizations: [],
    availableGroupsOrBranches: [],
    organizationsList: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  initialize();

  function initialize() {
    loadOrganizations();
    loadOrganization();
  }

  function loadOrganizations() {
    return organizationsService
      .getAvailableGoB({
        isActive: true,
        fields: ORGANIZATION.FIELDS.LIST
      })
      .then(function (data) {
        $scope.Model.availableGroupsOrBranches = data;
      });
  }

  function loadOrganization() {
    return accountService
      .readAccount({ id: $rootScope.CurrentAccount.id })
      .then(function (data) {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentAccount.idDefaultOrganization = data.idDefaultOrganization;
        // Set Model values
        $scope.Model.availableOrganizations = $filter('orderBy')(
          _.filter($rootScope.AvailableOrganizations, function (o) {
            return data.idOrganizations.indexOf(o.id) > -1;
          }),
          'GetName()'
        );
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('My organizations : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.hasGroupsOrBranches = function (organizationToDelete) {
    if (organizationToDelete.isBranch()) {
      return _.find($scope.Model.availableGroupsOrBranches, function (o) {
        return o.id === organizationToDelete.idParent;
      });
    } else if (organizationToDelete.isGroup()) {
      return _.find($scope.Model.availableGroupsOrBranches, function (o) {
        return o.id === organizationToDelete.idRoot;
      });
    } else {
      return undefined;
    }
  };
  $scope.organizationDelete = function ($event, organization) {
    uiService.toast({
      text: {
        p1: 'Organization',
        p2: 'deletion is',
        p3: 'disabled'
      },
      warn: true
    });
  };
  $scope.organizationDeleted = function (organization) {
    // $scope.Model.organizationsList.removeData(organization);
    // initialize();
  };
  $scope.$on('organizationAdd', function (e, $event) {
    eventService.organizationAdd({ event: $event });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.organizationAdded = function (organization) {
    navigationService.organizationChange({ idOrganization: organization.id, url: '/' });
  };
  $scope.setDefaultOrganization = function (organization) {
    $rootScope.CurrentAccount.idDefaultOrganization = organization.id;
    changesService.change();
  };
  $scope.switchOrganization = function ($event, organization) {
    $state.transitionTo('organizationSwitch');
    navigationService.organizationChange({
      idOrganization: organization.id,
      url: $location.absUrl()
    });
  };
  $scope.listReady = function (list) {
    $scope.Model.organizationsList = list;
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnChange: true });
  changesService.onFinish(saveChanges);

  function saveChanges() {
    var accountData = {
      id: $rootScope.CurrentAccount.id,
      idDefaultOrganization: $rootScope.CurrentAccount.idDefaultOrganization
    };
    return accountService.updateAccount(accountData).then(function (result) {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }
};
